module.exports = __webpack_public_path__ + "img/email-sent.128ffd22.svg";